import BreakpointSniffer from 'utils/BreakpointSniffer';

const DELAY_TIME = 5000;

export default (function(){
	let _button;
	let _parent;
	let _error;
	let timer;

	function init(wrapper, error) {
		_button = $(wrapper).find('button[type=submit]');
		_parent = $(_button).parent();
		_error = $(error);

		$(_parent).click(function() {
			if ($(_button).hasClass('wc-variation-selection-needed')) {
				promptError();
			}
		});
	}

	function promptError() {
		if (timer) {
			clearTimeout(timer);
			timer = null;
		}

		$(_error).addClass('is-active');
		timer = setTimeout(()=> {
			$(_error).removeClass('is-active');
		}, DELAY_TIME);
	}

	return { init };
})();